import { render, staticRenderFns } from "./ModalElement.vue?vue&type=template&id=768b47c8&scoped=true&"
import script from "./ModalElement.vue?vue&type=script&lang=js&"
export * from "./ModalElement.vue?vue&type=script&lang=js&"
import style0 from "./ModalElement.vue?vue&type=style&index=0&id=768b47c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768b47c8",
  null
  
)

export default component.exports